export const routes = {
    "/customer/:customerId/stressriskassessment/:stressriskassessmentId": {
        title: "Stress Risk Assessment",
        authorize: false
    },
    "/customer/:customerId/stressriskassessmentresults/:stressriskassessmentId": {
        title: "Stress Risk Assessment",
        authorize: false
    }
};
